<template>
    <div class="p-3 row">
        <!--<input-text class="col-12 col-md-8" label="Nome do arquivo" v-model="form.nomeArquivo" ref="nome" required/>-->
        <input-date-time class="col-12 col-md-4" label="Data de envio" v-model="form.data" ref="data" required/>
        <input-text class="col-12 col-md-4" type="number" :min="0" label="Versão" v-model="form.versao" ref="versao" required/>
        <input-select class="col-12 col-md-4" label="Tipo" :options="tipo" v-model="form.tipo" ref="tipo" required/>
        <div class="col-12 mb-2">
            <upload 
                    id="contrato_documentacao"
                    tituloArquivo="Arrastar Arquivo" 
                    selecioneArquivo="Selecionar Arquivo" 
                    type=".*"
                    :arquivo-download="form.conteudoBase64"
                    :arquivo-download-nome="form.nomeArquivoAWS"
                    @upload="(file, nomeArquivo, extensao)=> {                 
                        form.nomeArquivoAWS = nomeArquivo;
                        form.extensao = extensao;
                        form.conteudoBase64 = file;
                    }" />
        </div>
        <div class="col-12">
            <b-button variant="success" v-if="controles && permissao.c" @click="salvar">
                <i class="fa-solid fa-cloud-upload mr-2"></i>
                Upload do arquivo
            </b-button>
        </div>

        <div class="col-12 mt-3">
            <h6>Lista de arquivos</h6>
            <b-table head-variant="dark" hover :fields="colunas" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="download(data.item)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger" v-if="controles && permissao.d" class="mr-2" @click="excluir(data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputDateTime from '@/components/inputs/InputDateTime';
import InputText from '@/components/inputs/InputText';
import InputSelect from '@/components/inputs/InputSelect';
import Upload from '@/components/upload/Upload';

import {FormMixin} from '@/common/mixins/FormMixin';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import ProjetoGestaoService from '@/common/services/projeto_gestao/projeto_gestao.service';

import helpers from '@/common/utils/helpers';

export default {
    name: "ContratoDocumentacao",
    mixins: [FormMixin, AlertasMixin],
    components: {
        InputDateTime,
        InputText,
        InputSelect,
        Upload,
    },
    props : {
        projeto : {
            required: true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        form : {
            nomeArquivoAWS : '',
            extensao : '',
            conteudoBase64 : '',
            data : null,
            versao : null,
            tipo: null,
        },
        tipo : [
            { value : "Contratos", text : "Contratos"},
            { value : "DocumentosAdicionais", text : "Documentos adicionais"},
            { value : "Fotos", text : "Fotos"},
        ],
        colunas : [],
        itens : [],
    }),
    methods: {
        inicializarColunas : function(){
            this.colunas = [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "tipo", label:"Tipo",
                    formatter: (value) => this.tipo.find(el => el.value == value)?.text
                },
                { key: "data", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },

        limpar: function() {
            this.form = {
                nomeArquivo : '',
                extensao : '',
                conteudoBase64 : '',
                data : null,
                versao : null,
            };
        },
        salvar: function() {
            if(!this.validateState())
                return;

            if(!this.form.conteudoBase64){
                this.alertaErro('Informe o arquivo para salvar');
                return;
            }

            this.confirmar("Deseja realmente salvar o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                let form = this.form;
                form.projetoGestaoId = this.projeto.id;
                ProjetoGestaoService.salvarContratoDocumentacao(form).then(() => {
                    this.alertaSucesso("Arquivo salvo com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao salvar arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao salvar arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },

        excluir: function(id) {
            this.confirmar("Deseja realmente excluir o arquivo?").then(confirmado => {
                if(!confirmado)
                    return;
                    
                this.$store.dispatch(START_LOADING);
                ProjetoGestaoService.excluirContratoDocumentacao(id).then(() => {
                    this.alertaSucesso("Arquivo excluido com sucesso!");
                    this.buscarArquivos();
                }).catch(err => {
                    if((err.response ? err.response.status : 0) == 400){
                        this.alertaErro(`Erro ao excluir arquivo: ${err.data.errors}`);
                    }else{
                        this.alertaErro(`Erro ao excluir arquivo`);
                    }
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        },
        buscarArquivos: function() {
            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.listarContratoDocumentacao(this.ehTelaCooperada ? this.projeto.id : this.projeto.projetoGestaoId).then(res => {
                this.itens = res.data.data.itens;
            }).catch(() => {   
                this.alertaErro(`Erro ao buscar arquivos`);
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        download: function(item) {
            this.$store.dispatch(START_LOADING);

            ProjetoGestaoService.downloadXML('comprovante-arquivos', item.id)
                .then(response => {
                    helpers.baixarArquivo(response.data, response.headers);
                    this.alertaSucesso("Download do Arquivo Concluido!");               
                })
                .catch(err => {
                    console.log(err);
                    this.alertaErro("Erro ao fazer Download do Arquivo");
                })
                .finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
        },
        montar : function(){
            this.buscarArquivos();
        }
    },
    mounted() {
        this.inicializarColunas();
    },
    computed: {
        controles :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento' && this.projetoEditavel;
        },
        ehTelaCooperada :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento';
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoContrato');
        },
    }
}
</script>
<style lang="">
    
</style>